import styled from 'styled-components';

const MainSpinWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default MainSpinWrapper;
